export default __webpack_public_path__ + "static/media/attachments-icon.b59aaa10.svg";